
<template>
  <div class="home">
    <!-- Priority 1: Seniors -->
    <template v-if="showSeniors">
      <HomeSA :config="config" />
    </template>

    <!-- Priority 2: AUS / WPG -->
    <template v-else-if="showAus === 'Y' || showWpg === 'Y'">
      <HomeAW :config="config" />
    </template>

    <!-- Fallback -->
    <template v-else>
      <HomeSA :config="config" />
    </template>
  </div>
</template>

<script>
import HomeAW from "@/components/StarterHome.vue";
import HomeSA from "@/components/SecondHome.vue";
import axios from "axios";

export default {
  name: "First home",
  props: ["config"],

  components: {
    HomeAW,
    HomeSA
  },

  data() {
    return {
      showAus: 'N',
      showWpg: 'N',
      showSnr: 'N',
      showAll: 'N',
      showSeniors: false
    };
  },

  mounted() {
    const url = `https://api.aus.ocs-software.com/pgaaus/cache/aus/tmticx?multi=Y&tour=aus&tour=wpg&tour=snr&tour=all&maxdays=10&days=-5&randomadd=${Date.now()}`;

    axios.get(url)
      .then(({ data }) => {
        const getTournament = tour =>
          data?.[tour]?.[0]?.[0]?.data;

        const ausTournament = getTournament('aus');
        const wpgTournament = getTournament('wpg');
        const seniorsTournament = getTournament('snr');

        this.showAus = ausTournament ? 'Y' : 'N';
        this.showWpg = wpgTournament ? 'Y' : 'N';
        this.showSnr = seniorsTournament ? 'Y' : 'N';

        // Seniors always takes priority when a tournament exists
        this.showSeniors = !!seniorsTournament;
      })
      .catch(error => {
        console.error('API error:', error);
      });
  }
};
</script>
